import { makeStyles } from "tss-react/mui"
import { lightBlue, blueGrey } from "../../../../../../mp-core/themes/palette"

export const useStyles = makeStyles<{ hideIndentationMarkers: boolean }>()(
  ({ spacing, mixins }, { hideIndentationMarkers }) => ({
    item: {
      flexDirection: "row",
      alignItems: "center",
      gap: spacing(2),
      padding: spacing(2, 3),
      wordBreak: "break-all",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "#ECEEF1"
      },
      "&:focus, &:focus-within": {
        ...mixins.focusRing.ring
      }
    },
    selectedItem: {
      backgroundColor: lightBlue[50]
    },
    disabledItem: {
      color: blueGrey[300],

      "&:hover": {
        backgroundColor: "transparent"
      }
    },
    selectedDisabledItem: {
      color: blueGrey[800],
      backgroundColor: lightBlue[50],

      "&:hover": {
        backgroundColor: lightBlue[50]
      },

      "& rect": {
        fill: lightBlue[200],
        stroke: lightBlue[200]
      }
    },
    level: {
      whiteSpace: "nowrap",
      color: blueGrey[300],

      ...(hideIndentationMarkers
        ? {
            opacity: 0
          }
        : {})
    },
    checkbox: {
      padding: 0
    }
  })
)
